import {
  executionStatusGroup2,
  refundStatusOptions,
  returnStatusOptions,
  typeStatusOptions,
} from '@/model/service';

import * as Moment from 'dayjs';

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

export function setServiceTable () {
  const serviceTableCols = [
    {
      title: '售后单号',
      dataIndex: 'outRefundCode',
      key: 'outRefundCode',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '售后类型',
      dataIndex: 'type',
      key: 'type',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(typeStatusOptions, text);
      },
    },
    {
      title: '售后状态',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(executionStatusGroup2, text);
      },
    },
    {
      title: '退款状态',
      dataIndex: 'moneyStatus',
      key: 'moneyStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(refundStatusOptions, text);
      },
    },
    {
      title: '退货状态',
      dataIndex: 'goodsStatus',
      key: 'goodsStatus',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return convertToName(returnStatusOptions, text);
      },
    },
    {
      title: '关联金额',
      dataIndex: 'applyAmount',
      key: 'applyAmount',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
      },
    },
    {
      title: '订单编号',
      dataIndex: 'orderCode',
      key: 'orderCode',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '客户抬头',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '申请时间',
      dataIndex: 'applyTime',
      key: 'applyTime',
      width: 180,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '售后原因',
      dataIndex: 'reason',
      key: 'reason',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      width: 180,
      ellipsis: true,
      customRender: (text) => {
        return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
  ];

  return serviceTableCols;
}
